/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_RulesInputs */

const en_directory_footer_link_rules = /** @type {(inputs: Directory_Footer_Link_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rules`)
};

const zh_directory_footer_link_rules = /** @type {(inputs: Directory_Footer_Link_RulesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`收录规则`)
};

/**
* | output |
* | --- |
* | "Rules" |
*
* @param {Directory_Footer_Link_RulesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_rules = /** @type {((inputs?: Directory_Footer_Link_RulesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_RulesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_rules(inputs)
	return zh_directory_footer_link_rules(inputs)
});
export { directory_footer_link_rules as "directory.footer.link_rules" }